interface StickyFooterCTAProps {
  onOpenModal: () => void;
}

export default function StickyFooterCTA({ onOpenModal }: StickyFooterCTAProps) {
  return (
    <>
      {/* Main Footer */}
      <footer className="bg-gray-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            {/* Company Info */}
            <div className="md:col-span-2">
              <img
                src="https://static.readdy.ai/image/042557a158b596551b7acb61d66aac00/ae9ed59fe1896a8f4d9b0d1f20cc888c.png"
                alt="Mobile Welding Repair and Fabrication"
                className="h-16 w-auto mb-4"
              />
              <p className="text-gray-300 mb-6 leading-relaxed">
                Professional mobile welding and fabrication services. We bring precision, reliability, and expertise directly to your location.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-orange-500 rounded-lg transition-colors duration-300 cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-orange-500 rounded-lg transition-colors duration-300 cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-orange-500 rounded-lg transition-colors duration-300 cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-bold mb-4">Services</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer">Emergency Repair</a></li>
                <li><a href="#" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer">Custom Fabrication</a></li>
                <li><a href="#" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer">Commercial Welding</a></li>
                <li><a href="#" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer">Structural Welding</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-bold mb-4">Contact</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-phone-line text-orange-500"></i>
                  </div>
                  <div className="text-gray-300">
                    <a href="tel:+15073980496" className="hover:text-orange-500 transition-colors cursor-pointer block">(507) 398-0496</a>
                    <a href="tel:+15072263462" className="hover:text-orange-500 transition-colors cursor-pointer block">(507) 226-3462</a>
                  </div>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-orange-500"></i>
                  </div>
                  <div className="text-gray-300">
                    <div className="text-sm">Madison Lake, MN</div>
                    <div className="text-sm">Eagan, MN</div>
                  </div>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-mail-line text-orange-500"></i>
                  </div>
                  <a href="mailto:info@mobilewelding.com" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer">
                    info@mobilewelding.com
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-time-line text-orange-500"></i>
                  </div>
                  <div className="text-gray-300">
                    <div className="font-semibold mb-1">Hours:</div>
                    <div className="text-sm">Mon-Fri: Emergency calls until 9pm</div>
                    <div className="text-sm">Friday: All night service</div>
                    <div className="text-sm">Saturday: Until 11:59pm</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 Mobile Welding Repair and Fabrication. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-orange-500 text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>

      {/* Sticky CTA Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-orange-500 shadow-2xl z-50 transform transition-transform duration-300">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-center sm:text-left">
              <h3 className="text-white font-bold text-lg mb-1">
                Need Welding Services? We're Ready Mon-Sat
              </h3>
              <p className="text-orange-100 text-sm">
                Emergency calls: Weekdays until 9pm • All night Friday • Saturday until 11:59pm
              </p>
            </div>
            <div className="flex gap-3">
              <a
                href="tel:+15073980496"
                className="whitespace-nowrap bg-white hover:bg-gray-100 text-orange-500 font-bold text-base px-6 py-3 rounded-lg transition-all duration-300 cursor-pointer flex items-center gap-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                (507) 398-0496
              </a>
              <button
                id="sticky-cta-btn"
                onClick={onOpenModal}
                className="whitespace-nowrap bg-gray-900 hover:bg-gray-800 text-white font-bold text-base px-6 py-3 rounded-lg transition-all duration-300 cursor-pointer"
              >
                Get Estimate
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Spacer to prevent content from being hidden behind sticky bar */}
      <div className="h-24"></div>
    </>
  );
}
